/**
 * Left padding for the section labels. Needed to keep them spaced appropriately
 * when adjusting the label position
 */
export const LABEL_PADDING_AT_REST_REM = 1.2;

/**
 * We want to be able to create an object that maps a tableId to a list of template infos.
 * However, some template infos do not have a tableId. In order to include them in the same
 * map, we key them with this constant (tableIds cannot be negative).
 */
export const NO_TABLE_OR_GROUP_FOR_INFO = 'NO TABLE OR TABLE GROUP';

/**
 * We want to be able to create an object that maps tableGroupId to the list of tables
 * that are in that group. Not all tables are part of a group, however, so we key them with this constant.
 */
export const NO_TABLE_GROUP_FOR_TABLE = -Infinity;

/**
 * We want to be able to create an object that maps a ticketTypeId to information about that
 * experience's turn time. However, not every turn time has a ticketTypeId. In order to include those,
 * we key them with this constant (ticketTypeIds cannot be negative).
 */
export const NO_TICKET_TYPE_ID_FOR_TURN = -1;

/**
 * If somehow there are no configured turn times, the default size ranges
 * are 1-2, 3-4, 5-6, 7-8, and 9+
 */
export const TURN_DEFAULT_PARTY_SIZES: Array<{
  minPartySize: string;
  maxPartySize: string;
  expectedTurnTimeMinutes: string;
}> = [
  { minPartySize: '1', maxPartySize: '2', expectedTurnTimeMinutes: '90' },
  { minPartySize: '3', maxPartySize: '4', expectedTurnTimeMinutes: '105' },
  { minPartySize: '5', maxPartySize: '6', expectedTurnTimeMinutes: '120' },
  { minPartySize: '7', maxPartySize: '8', expectedTurnTimeMinutes: '135' },
  { minPartySize: '9', maxPartySize: '', expectedTurnTimeMinutes: '150' },
];

/**
 * The height / width (in rem) of a square on the template screen (including padding).
 * This value comes from the designs / css, and both need to be updated if one changes.
 * Each grid square is 60px and the border on the right / bottom is 1px
 */
export const SLOT_SIDE_LENGTH_REM = 6;
export const SLOT_SIDE_LENGTH_REM_SMALL = 4.8;
export const SLOT_SIDE_LENGTH_PX_SMALL = SLOT_SIDE_LENGTH_REM_SMALL * 10;
export const SLOT_SIDE_BLOCKED_TIME_BACKGROUND_OFFSET_PER_SQUARE_LENGTH_REM = 0.8;

/**
 * The height offset for a template info slot. Used to arrange slots appropriately
 * when there are conflicts.
 */
export const SLOT_HEIGHT_OFFSET_REM = 6;
export const SLOT_HEIGHT_OFFSET_REM_SMALL = 4.8;

/**
 * The amount of minutes each slot represents on the grid
 */
export const SQUARE_INCREMENT_MINUTES = 15;
